export const RowType = {
    heading: 'heading',
    category_total: 'category_total',
    type_total: 'type_total',
    spacer: 'spacer',
    normal: 'normal',
};
